import { Component, Input } from '@angular/core';

import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';
import { Match } from '@libs/src/models/match.interfaces';

@Component({
  selector: 'app-group-intro-feedback-prompt',
  templateUrl: './group-intro-feedback-prompt.component.html',
})
export class GroupIntroFeedbackPromptComponent {
  @Input() account: Account;
  @Input() group: Group;
  @Input() match: Match;
  @Input() source: string;
}
